"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySection = exports.KeyBlock = exports.MonthBlock = exports.MonthsBlock = exports.YearBlock = exports.Circle = exports.TextCircle = void 0;
const base_react_components_1 = require("@navinc/base-react-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.TextCircle = (0, styled_components_1.default)(base_react_components_1.Copy).attrs({ as: base_react_components_1.Copy, size: 'xs', bold: true }).withConfig({ displayName: "reports-TextCircle", componentId: "reports-3n76rf" }) `
  color: ${({ $color }) => $color !== null && $color !== void 0 ? $color : base_react_components_1.theme.white};
`;
exports.Circle = styled_components_1.default.div.withConfig({ displayName: "reports-Circle", componentId: "reports-phpcm0" }) `
  display: flex;
  border-radius: 50%;
  background-color: ${({ $backgroundColor }) => $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : base_react_components_1.theme.neutral500};
  color: ${({ $color }) => $color !== null && $color !== void 0 ? $color : base_react_components_1.theme.white};
  justify-content: center;
  align-items: center;
  width: ${base_react_components_1.theme.gu(3)};
  height: ${base_react_components_1.theme.gu(3)};

  & > ${exports.TextCircle}: {
    background-color: ${({ $backgroundColor }) => $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : base_react_components_1.theme.neutral500};
    color: ${({ $color }) => $color !== null && $color !== void 0 ? $color : base_react_components_1.theme.white};
  }
`;
exports.YearBlock = styled_components_1.default.div.withConfig({ displayName: "reports-YearBlock", componentId: "reports-hmb2c8" }) `
  margin-bottom: 16px;
`;
exports.MonthsBlock = styled_components_1.default.div.withConfig({ displayName: "reports-MonthsBlock", componentId: "reports-13gfez0" }) `
  display: grid;
  grid-template-areas: 'Dec Nov Oct Sep Aug Jul Jun May Apr Mar Feb Jan';
  grid-template-columns: repeat(12, ${base_react_components_1.theme.gu(4)});
  justify-content: space-around;

  @media (max-width: 500px) {
    grid-template-areas:
      'Dec Nov Oct Sep Aug Jul'
      'Jun May Apr Mar Feb Jan';
    grid-template-columns: repeat(6, ${base_react_components_1.theme.gu(4)});
  }
`;
exports.MonthBlock = styled_components_1.default.div.withConfig({ displayName: "reports-MonthBlock", componentId: "reports-11xk0kj" }) `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-area: ${({ $month }) => $month};
`;
exports.KeyBlock = styled_components_1.default.div.withConfig({ displayName: "reports-KeyBlock", componentId: "reports-1jskezr" }) `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  grid-gap: ${base_react_components_1.theme.gu(2)};
`;
exports.KeySection = styled_components_1.default.div.withConfig({ displayName: "reports-KeySection", componentId: "reports-1fa1qck" }) `
  display: grid;
  grid-template-columns: ${base_react_components_1.theme.gu(4)} auto;
  grid-gap: ${base_react_components_1.theme.gu(1)};
`;
//# sourceMappingURL=styles.js.map